// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N1_G","badges":"styles_badges__2vqlJ"};